module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"agent":{"title":"Agent","title0":"Agents","tabs":{"agent":"Agent","networks":"Networks","settings":"Settings","logs":"Logs"},"newAgent":"New agent"}},"ru":{"agent":{"title":"Агент","title0":"Агенты","tabs":{"agent":"Агент","networks":"Сети","settings":"Настройки","logs":"Журнал"},"newAgent":"Новый агент"}}}')
  delete Component.options._Ctor
}
